module.exports = __webpack_public_path__ + "img/plus-circle.5f50ecb.svg";